import React from 'react'
import WebFrame from '~/elements/webFrame'
import './styles.css'

const WebFrame02 = (props) => {
  const { title, rawText } = props.data
  return <WebFrame className="webFrame02" title={title} iframeSrc={rawText}/>
}

export default WebFrame02
